import React from "react";
import { motion } from "framer-motion";

const row1 = [
  "/lp/banners/sample-fashion-grid.png",
  "/lp/banners/sample-skincare-aqua.png",
  "/lp/banners/sample-housing-01.png",
  "/lp/banners/sample-bellsales-visual.png",
  "/lp/banners/sample-salesbox-rpo-01.png",
  "/lp/banners/sample-sorndy.png",
  "/lp/banners/sample-fashion-grid.png",
  "/lp/banners/sample-skincare-aqua.png",
  "/lp/banners/sample-housing-01.png",
  "/lp/banners/sample-bellsales-visual.png",
  "/lp/banners/sample-salesbox-rpo-01.png",
  "/lp/banners/sample-sorndy.png",
];

const row2 = [
  "/lp/banners/sample-housing-02.png",
  "/lp/banners/sample-sabu-chat.png",
  "/lp/banners/sample-salesbox-rpo-02.png",
  "/lp/banners/sample-salesbox-urgent.png",
  "/lp/banners/sample-sorndy.png",
  "/lp/banners/sample-housing-02.png",
  "/lp/banners/sample-sabu-chat.png",
  "/lp/banners/sample-salesbox-rpo-02.png",
  "/lp/banners/sample-salesbox-urgent.png",
  "/lp/banners/sample-sorndy.png",
  "/lp/banners/sample-housing-02.png",
  "/lp/banners/sample-sabu-chat.png",
];

function ScrollRow({
  images,
  direction,
  duration,
}: {
  images: string[];
  direction: "left" | "right";
  duration: number;
}) {
  const publicUrl = process.env.PUBLIC_URL || "";
  return (
    <div className="relative overflow-hidden">
      <motion.div
        className="flex gap-4"
        animate={{
          x:
            direction === "left"
              ? [0, -(276 * (images.length / 2))]
              : [-(276 * (images.length / 2)), 0],
        }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration,
            ease: "linear",
          },
        }}
      >
        {images.map((src, i) => (
          <div
            key={`${src}-${i}`}
            className="flex-shrink-0 w-[220px] h-[220px] md:w-[260px] md:h-[260px] rounded-2xl overflow-hidden border border-[rgba(29,25,38,0.08)]"
          >
            <img
              src={`${publicUrl}${src}`}
              alt="広告バナーサンプル"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        ))}
      </motion.div>
    </div>
  );
}

const BannerGallerySection: React.FC = () => {
  return (
    <section id="gallery" className="py-24 md:py-40">
      <div className="max-w-[1200px] mx-auto px-6 mb-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h2 className="text-[36px] md:text-[64px] font-extrabold tracking-[-0.03em]">
            すべてAIが生成した、
            <br className="hidden md:block" />
            <span
              className="bg-clip-text text-transparent"
              style={{
                backgroundImage:
                  "linear-gradient(to right, #3eb298, #5a69c1)",
              }}
            >
              広告バナー。
            </span>
          </h2>
          <p className="mt-5 text-[18px] text-[#1d1926]/60 max-w-lg mx-auto">
            業界・トーン・目的に合わせた多彩なスタイルで、
            プロ品質のバナーを量産します。
          </p>
        </motion.div>
      </div>

      <div className="space-y-4">
        <ScrollRow images={row1} direction="left" duration={60} />
        <ScrollRow images={row2} direction="right" duration={65} />
      </div>
    </section>
  );
};

export default BannerGallerySection;
